// Inbound call screen-pop — SPEC §10: < 1s alert with caller number + patient link.
// Auto-dismisses after 15 seconds.

import { useEffect, type JSX } from "react";

export interface InboundCallPayload {
  caller_number:   string;
  patient_id:      string | null;
  exotel_call_sid: string | null;
}

interface Props {
  event:     InboundCallPayload | null;
  onDismiss: () => void;
}

export function CallScreenPop({ event, onDismiss }: Props): JSX.Element | null {
  useEffect(() => {
    if (!event) return;
    const t = setTimeout(onDismiss, 15_000);
    return (): void => clearTimeout(t);
  }, [event, onDismiss]);

  if (!event) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 w-72 bg-white border-2 border-navy-400 rounded-xl shadow-2xl p-4 animate-in fade-in slide-in-from-bottom-2">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-[10px] font-semibold text-navy-700 uppercase tracking-widest mb-0.5">Inbound Call</p>
          <p className="text-base font-bold text-slate-900 truncate">{event.caller_number}</p>
        </div>
        <button
          onClick={onDismiss}
          className="shrink-0 text-slate-400 hover:text-slate-700 text-lg leading-none mt-0.5"
          aria-label="Dismiss"
        >
          ✕
        </button>
      </div>
      {event.patient_id && (
        <a
          href={`/patients/${event.patient_id}`}
          className="mt-2 block text-xs font-medium text-navy-700 hover:underline"
        >
          View patient record →
        </a>
      )}
    </div>
  );
}
